import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function noPositionBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Cannot complete action, no position exists.
        {parsedStatusObj.symbol ? '[' + parsedStatusObj.symbol + ']' : ''}
      </Body3>
    </td>
  );
}
